import { useState } from "react";
import styles from "./RunView.module.css";

// The (i) that opens a window's breakdown, and its open state.
export const useBreakdownToggle = () => {
  const [open, setOpen] = useState(false);
  const button = (
    <button
      type="button"
      className={styles.contextInfo}
      aria-expanded={open}
      aria-label={open ? "Hide what fills this context window" : "Show what fills this context window"}
      title="What fills this context window"
      onClick={() => setOpen((v) => !v)}
    >
      i
    </button>
  );
  return { open, button };
};
